<template>
    <footer class="app-footer">
        <span v-if="hasUser">
            <b-badge variant="success" pill class="badge badge--online mr-2">&nbsp;</b-badge>
            {{ userEmailAddress }}
        </span>
        <span v-else>
            <b-badge variant="warning" pill class="badge badge--online mr-2">&nbsp;</b-badge>
            Guest: <router-link :to="{name: 'sign-up'}">Sign up</router-link> or
            <router-link :to="{name: 'login'}">Log in</router-link>
        </span> |
        <a href="https://fuga.cloud/terms-of-use/" title="Terms of use">Terms of use</a> |
        <a href="https://fuga.cloud/privacy-policy/" title="Privacy policy">Privacy policy</a> |
        <a href="https://fuga.cloud/service-level-agreement/" title="Service Level Agreement">Service Level Agreement</a>
    </footer>
</template>

<script>
export default {
    computed: {
        userEmailAddress() {
            return this.$store.state.user.info.email_address;
        }
    }
}
</script>
